import {observable, makeObservable} from "mobx";
import {BaseViewModel} from "../base-view-model";
import {EntityViewModel} from "./entity.view-model";

export class EntityGroupViewModel extends BaseViewModel {
  @observable entities: Array<EntityViewModel>;

  constructor(id: Number, title: String, results: Array<EntityViewModel>, sortIndex: Number) {
    super({id, name: title});

    this.entities = results;
    !isNaN(sortIndex) && (this.sortIndex = sortIndex);

    makeObservable(this);
  }

  get title(): String {
    return this.name;
  }
}
